import { sendActionsReport } from "./sendActionsReport";
import { initializeSentry } from "../shared/config/initializeSentry";
import { executeRulesForMatchedDomain } from "./executeRulesForMatchedDomain";
import { RuleAction } from "./RuleAction";
import { logInfo } from "../utils/log";
import { isMatchedIframe } from "../utils/isMatchedIframe";
import {
  CookieManagementPlatformRules,
  searchForCookieManagementPlatforms,
} from "../utils/searchForCookieManagementPlatforms";
import { isCookieBlockerEnabled } from "../utils/isCookieBlockerEnabled";
import { normalizeUrl } from "../utils/normalizeUrl";

export type ClickAllMessage = {
  action: "click_all";
  clicks: Array<RuleAction>;
};

type SearchManagingPlatformsMessage = {
  action: "search_managing_platforms";
  searchRules: Array<CookieManagementPlatformRules>;
};

type ContentScriptMessage = ClickAllMessage | SearchManagingPlatformsMessage;

const getUrl = () => {
  const result =
    window !== window.top ? document.referrer : window.location.href;
  logInfo("Getting iframe URl", {
    result,
    hef: window.location.href,
    referrer: document.referrer,
  });
  return window.location.href;
};

export const initContentScript = () => {
  logInfo("Content script initialized inside: ", window.location.href);
  initializeSentry();

  chrome.runtime.onMessage.addListener(
    async (
      message: ContentScriptMessage,
      sender: chrome.runtime.MessageSender
    ) => {
      if (!message || !message.action) {
        logInfo("No Content Script action in message. Ignoring.");
        return;
      }
      logInfo("Running content script action: ", message);

      // Check if cookie blocker is disabled first
      if (!(await isCookieBlockerEnabled())) {
        logInfo(
          "Cookie blocker is disabled. Ignoring all content script actions."
        );
        return;
      }

      const isIframe = window.self !== window.top;

      logInfo("Running content script in iframe: ", isIframe);

      switch (message.action) {
        case "click_all":
          if (isIframe && !isMatchedIframe(message)) {
            logInfo(
              "Ignoring click_all in iframe with src: ",
              (window.frameElement as any)?.src
            );
            break;
          }
          logInfo("Clicking all: ", message.clicks);
          const report = await executeRulesForMatchedDomain(message.clicks);
          logInfo("Ready to send report: ", report);
          sendActionsReport(report);
          break;
        case "search_managing_platforms":
          if (isIframe) {
            logInfo("Ignoring search for managing platforms in iframe");
            break;
          }
          const mangementPlatformsReport =
            await searchForCookieManagementPlatforms(message.searchRules);
          sendActionsReport(mangementPlatformsReport);
          break;
        default:
          logInfo("Message with unknown action received: ", message);
          break;
      }
    }
  );

  const url = getUrl();
  const normalizedUrl = normalizeUrl(url);

  chrome.runtime.sendMessage({
    action: "getBannerActionRules",
    url: normalizedUrl,
  });
};
